/**
 * Add search params to a given url
 *
 * @method addSearchParams
 *
 * @param  {url}
 *         Url with existing/non existing search params
 *
 * @param  {params}
 *         Params to be appended to the url
 *
 * @return {URL} Url with appended params
 */
export const addSearchParams = (url: URL, params: Record<string, any>): URL =>
  new URL(
    `${url.origin}${url.pathname}?${new URLSearchParams([
      ...url.searchParams.entries(),
      ...Object.entries(params),
    ])}`
  )
